<template>
<div id="pages-portfolio">
	<div class="nav navbar bg-light sticky-top border-bottom w-100">
		<h1 class="small mb-0 w-100">
			<img src="../assets/logo.png" height="20rem" style="vertical-align: bottom;">
			Cheng Vue
			<span class="text-muted text-uppercase small">
				Aspiring Programmer
			</span>
			<router-link to="/" class="float-right">Back</router-link>
		</h1>
	</div>
	<div class="px-3 py-2">
		<h3 class="text-center mt-2">Web Applications / Websites</h3>
		<div class="d-flex flex-column h-100 text-center">

			<div class="card mb-3" style="overflow: hidden">
				<div class="d-md-flex flex-row">
					<div class="col-sm-12 col-md-5 p-0">
						<img src="/images/portfolio/governmentnavigator/homepage.png" class="img-fluid">
					</div>
					<div class="col-sm-12 col-md-7 p-0 text-left">
						<div class="text-white navbar bg-primary">
							Government Navigator
							<span class="small font-weight-light">Under employment at e.Republic Inc</span>
						</div>
						<div class="p-3 border-bottom">
							<h5 class="font-weight-normal">Primary Role</h5>
							<p class="font-weight-light mb-0">I maintain existing, scope and create, and 
							provide technical insight of all system features.</p>
						</div>
						<div class="p-3 border-bottom">
							<div class="row">
								<div class="col">
									<h5 class="font-weight-normal">Lead Features</h5>
									<p class="font-weight-light mb-0">
										<ul>
											<li>Account / User Management</li>
											<li>Analytics Tracking and Reporting</li>
											<li>Opportunities / Content Editors</li>
											<li>Data Import Tools <span class="small">( Users / Accounts / Misc. Content )</span></li>
										</ul>
									</p>
								</div>
								<div class="col">
									<h5 class="font-weight-normal">Assisted Features</h5>
									<p class="font-weight-light mb-0">
										<ul>
											<li>Account License Structuring</li>
											<li>Custom MVC Framework</li>
											<li>Database Design</li>
											<li>Full System Rebuild</li>
										</ul>
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="card" style="overflow: hidden">
				<div class="d-md-flex flex-row">
					<div class="col-sm-12 col-md-5 order-1 p-0">
						<img src="/images/portfolio/media_library/edit.png" class="img-fluid">
					</div>
					<div class="col-sm-12 col-md-7 p-0 text-left">
						<div class="text-white navbar bg-primary">
							e.Republic Media Library
							<span class="small font-weight-light">Under employment at e.Republic Inc</span>
						</div>
						<div class="p-3 border-bottom">
							<h5 class="font-weight-normal">Primary Role</h5>
							<p class="font-weight-light mb-0">Rebuilt the current implementation of the media library and replace the 
							previous Rackspace CDN storage with AWS S3.</p>
						</div>
						<div class="p-3 border-bottom">
							<div class="row">
								<div class="col">
									<h5 class="font-weight-normal">Lead Features</h5>
									<p class="font-weight-light mb-0">
										<ul>
											<li>App Embed Functionality</li>
											<li>HTML web app</li>
											<li>S3 integration</li>
											<li>Server API Calls</li>
										</ul>
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</div>
</template>

<script>
export default {
	name: 'pages-portfolio'
}

</script>

<style>

</style>
